var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgMenu = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 28,
  height: 20,
  viewBox: "0 0 28 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "V"
}, /*#__PURE__*/React.createElement("path", {
  id: "Line 4",
  d: "M26 18L2 18",
  stroke: "#0A3161",
  strokeWidth: 3,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "Line 5",
  d: "M26 10L14 10",
  stroke: "#0A3161",
  strokeWidth: 3,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "Line 6",
  d: "M26 2L2 2",
  stroke: "#0A3161",
  strokeWidth: 3,
  strokeLinecap: "round"
}))));
export { SvgMenu as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjgiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyOCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgaWQ9IlYiPgo8cGF0aCBpZD0iTGluZSA0IiBkPSJNMjYgMThMMiAxOCIgc3Ryb2tlPSIjMEEzMTYxIiBzdHJva2Utd2lkdGg9IjMiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPgo8cGF0aCBpZD0iTGluZSA1IiBkPSJNMjYgMTBMMTQgMTAiIHN0cm9rZT0iIzBBMzE2MSIgc3Ryb2tlLXdpZHRoPSIzIiBzdHJva2UtbGluZWNhcD0icm91bmQiLz4KPHBhdGggaWQ9IkxpbmUgNiIgZD0iTTI2IDJMMiAyIiBzdHJva2U9IiMwQTMxNjEiIHN0cm9rZS13aWR0aD0iMyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIi8+CjwvZz4KPC9zdmc+Cg==";